<template>
   <div class="pagination--container" :class="classes">
      <span v-if="pages > 2" class="pagination__link" @click="changePage('first')">
         <NuxtLink :to="page_url(1)"><i class="fas fa-angle-double-left"></i></NuxtLink>
      </span>

      <span class="pagination__link" @click="changePage('prev')">
         <NuxtLink :to="page_url(lastPage)"><i class="fas fa-angle-left"></i></NuxtLink>
      </span>

      <span v-for="page in display_range" 
         :key="page" 
         @click="setPage(page)"
         :class="page === currentPage ? 'active' : null" 
         class="pagination__link">
            <NuxtLink :to="page_url(page)">{{ page }}</NuxtLink>
      </span>
      
      <span class="pagination__link" @click="changePage('next')">
         <NuxtLink :to="page_url(nextPage)"><i class="fas fa-angle-right"></i></NuxtLink>
      </span>
      
      <span v-if="pages > 2" class="pagination__link" @click="changePage('last')">
         <NuxtLink :to="page_url(pages)"><i class="fas fa-angle-double-right"></i></NuxtLink>
      </span>
   </div>
</template>

<script>
export default {
   data() {
      return {
         currentPage: this.active_page
      }
   },
   props: {
      pages: { type: Number, default: null },
      max_pages: {type: Number, default: 5},
      active_page: {type: Number, default: 1}
   },
   methods: {
      checkPage(position) {
         if (position == 'first') {
            return this.currentPage == 1 ? true : false
         }
         if (position == 'last') {
            return this.currentPage == this.pages ? true : false
         }
      },
      changePage(dir) {
         let first = this.checkPage('first') //returns true if active page is the first page
         let last = this.checkPage('last') //returns true if active page is the last page

         if (dir === 'next' && !last) {
            this.currentPage++
         }

         if (dir === 'first') {
            this.currentPage = 1
         }

         if (dir === 'prev' && !first) {
            this.currentPage--
         }

         if (dir === 'last') {
            this.currentPage = this.pages
         }

         this.$emit('input', this.currentPage)
      },
      setPage(index) {
         this.currentPage = index
         this.$emit('input', this.currentPage)
      },
      page_url: function (page = 1) {
         //page > this.pages ? alert('stop') : alert('go')

         const query = Object.assign({}, this.query)
         query['page'] = page
         return `${this.path}?${new URLSearchParams(query).toString()}`
      },
   },
   computed: {
      nextPage() {
         return this.currentPage + 1 > this.pages ? this.pages : this.currentPage + 1
      },
      lastPage() {
         return this.currentPage - 1 == 0 ? 1 : this.currentPage - 1
      },
      path() {
         return this.type != 'table' ? this.$route.path : null
      },
      query() {
         return this.type != 'table' ? this.$route.query : null
      },
      display_range() {
         const distance = this.max_pages / 2
         const mod = Math.floor(distance) !== distance ? 1 : 0
         let start = this.currentPage - Math.floor(distance)
         let end = this.currentPage + Math.floor(distance)

         while (start <= 0) {
            start += 1
            end += 1
         }

         while (end - (1 - mod) > this.pages) {
            start -= 1
            if (start < 1) {
               start = 1
            }
            end -= 1
         }

         return [...Array((end - start) + mod).keys()].map(i => i + start)      
      },
      classes() {
         return [this.$tiscPlugin.theme]
      }
   }
}
</script>

<style lang="scss" scoped>
@import '~/assets/SCSS/Base/00_functions.scss';
@import '~/assets/SCSS/Base/01_variables.scss';
@import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Elements/pagination.scss';
</style>